import React, { useState, useEffect } from 'react';
import './header.css';
import { useDispatch, useSelector } from "react-redux";
import {
    getBookingSagaAction,
    getFiltersSagaAction,
    getSubscriptionsSagaAction,
    getMyReservesSagaAction
} from "../../redux/sagaActions";
import {
    filtersAction,
    setScheduleAction,
    setUserBarAction,
    setMobileMenuAction,
    setChoiceAddressFormAction
} from "../../redux/actions";
import { SCHEDULE_INITIAL } from "../../redux/initialStateConstants";

const Header = () => {
    const dispatch = useDispatch();
    const booking = useSelector(state => state.booking);
    const filters = useSelector(state => state.filters);
    const user = useSelector(state => state.user);
    const schedule_active = useSelector(state => state.schedule_active);
    const choice_address_form = useSelector(state => state.choice_address_form);

    const [filtersActive, setFiltersActive] = useState(false);

    useEffect(() => {
        // Активное состояние фильтров
        if (
            filters.coaches.filter(el => el.active).length
            || filters.types.filter(el => el.active).length
        ) {
            setFiltersActive(true);
        }
        else {
            setFiltersActive(false);
        }
    }, [filters]);

    return (
        <div className="header">
            <div className="header__menu"
                onClick={ () => {
                    dispatch(setMobileMenuAction(true));
                } }
            />
            <div className="header__calendar">
                <div
                    className={ `header__nav header__nav--prev ${ !booking.yesterday ? 'header__nav--inactive ' : '' }` }
                    onClick={ () => dispatch(getBookingSagaAction({ date: booking.yesterday })) }
                />
                <div className="header__date-wrapper">
                    <div className="header__date">{ booking.date_formatted }</div>
                    <div className="header__day">{ booking.day_name }</div>
                </div>
                <div
                    className="header__nav header__nav--next"
                    onClick={ () => dispatch(getBookingSagaAction({ date: booking.tomorrow }))}
                />
            </div>
            {
                choice_address_form.addresses.length > 1 && choice_address_form.current_address &&
                <div className="header__current-address">{ choice_address_form.current_address }</div>
            }
            <div className="header__buttons">
                {
                    choice_address_form.addresses.length > 1 &&
                    <div className="header__button header__address"
                         onClick={ () => {
                             dispatch(setChoiceAddressFormAction({
                                 ...choice_address_form,
                                 open: true
                             }));
                         } }
                    />
                }
                {
                    user.id &&
                    <>
                        <div className="header__button header__my-services" onClick={ () => {
                            // Запрашиваем список записей
                            dispatch(getMyReservesSagaAction());
                        } }/>
                        {
                            schedule_active === 1 &&
                            <div className="header__button header__services" onClick={ () => {
                                // Открываем компонент с расписанием
                                dispatch(setScheduleAction({
                                    ...SCHEDULE_INITIAL,
                                    open: true
                                }));
                            } }/>
                        }
                    </>
                }
                <div className={ `header__button header__filter ${ filtersActive ? 'header__filter--active' : '' }` } onClick={ () => {
                    // Открываем фильтры
                    dispatch(filtersAction({ ...filters, open: true }));
                    // Запрашиваем фильтры
                    dispatch(getFiltersSagaAction());
                } }/>
                <div className={ `header__button header__user ${ !user.id ? 'header__user--signin' : '' }` }
                    onClick={ () => {
                        // Запрашиваем список абонементов, если пользователь залогинен
                        if (user.id) {
                            dispatch(getSubscriptionsSagaAction());
                        }

                        dispatch(setUserBarAction(true));
                    } }
                />
            </div>
        </div>
    );
};

export default Header;